/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Scope_Output5Inputs */

const en_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint contract`)
};

const ar_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد السباق`)
};

const bn_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্প্রিন্ট চুক্তি`)
};

const de_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint-Vertrag`)
};

const es_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato del sprint`)
};

const fr_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrat de sprint`)
};

const pt_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato do sprint`)
};

const zh_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺合同`)
};

const tr_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint sözleşmesi`)
};

const ru_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор спринта`)
};

const pl_svc_mvp_sprint_scope_output5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa sprintu`)
};

/**
* | output |
* | --- |
* | "Sprint contract" |
*
* @param {Svc_Mvp_Sprint_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_scope_output5 = /** @type {((inputs?: Svc_Mvp_Sprint_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "de") return de_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "es") return es_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_scope_output5(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_scope_output5(inputs)
	return en_svc_mvp_sprint_scope_output5(inputs)
});
export { svc_mvp_sprint_scope_output5 as "svc_mvp-sprint_SCOPE_output" }